// extracted by mini-css-extract-plugin
module.exports = {"container":"dateTime__container___3UN4j","is-today":"dateTime__is-today___yiYe8","time":"dateTime__time___2doVF","date":"dateTime__date___2QS99"};